import React from 'react'
import MetricProgressCard, { ChartOptions } from '../../../cards/MetricProgressCard'
import { Model } from '../../../../types/models/model'
import * as S from '../styles'

interface MetricProgressGridProps {
  projectAnnotationType: Model['annotation_type'] | undefined
  gradient: string
  getMetricProgressData: (metricKey: string) => {
    labels: string[]
    datasets: {
      label: string
      data: number[]
      borderColor: string
      backgroundColor: string
      tension: number
    }[]
  }
  chartOptions: ChartOptions
  model1Color: {
    border: string
    background: string
  }
  model2Color: {
    border: string
    background: string
  }
}

const MetricProgressGrid: React.FC<MetricProgressGridProps> = ({
  projectAnnotationType,
  gradient,
  getMetricProgressData,
  chartOptions,
  model1Color,
  model2Color,
}) => {
  const getDataWithColors = (metricKey: string) => {
    const data = getMetricProgressData(metricKey)
    return {
      ...data,
      datasets: data.datasets.map((dataset, index) => ({
        ...dataset,
        borderColor: index === 0 ? model1Color.border : model2Color.border,
        backgroundColor: index === 0 ? model1Color.background : model2Color.background,
      })),
    }
  }

  return (
    <>
      {projectAnnotationType === 'bounding_box' ||
      projectAnnotationType === 'oriented_bounding_box' ? (
        <S.MetricsGrid>
          <MetricProgressCard
            title="mAP50-95 Progress"
            gradient={gradient}
            data={getDataWithColors('mAP')}
            options={chartOptions}
          />
          <MetricProgressCard
            title="F1 Score Progress"
            gradient={gradient}
            data={getDataWithColors('f1')}
            options={chartOptions}
          />
          <MetricProgressCard
            title="Precision Progress"
            gradient={gradient}
            data={getDataWithColors('precision')}
            options={chartOptions}
          />
          <MetricProgressCard
            title="Recall Progress"
            gradient={gradient}
            data={getDataWithColors('recall')}
            options={chartOptions}
          />
        </S.MetricsGrid>
      ) : (
        <MetricProgressCard
          title="Accuracy Progress"
          gradient={gradient}
          data={getDataWithColors('accuracy')}
          options={chartOptions}
        />
      )}
    </>
  )
}

export default MetricProgressGrid
